import { InboxMenuItem } from "./inbox-models";

export const GenerateInboxTitleMenuItem = (title: string) => {
  return {
    menuItemType: "TITLE",
    label: title,
  } as InboxMenuItem;
};
